import React, { useContext } from "react";
import { CheckoutContext } from "../../context/CheckoutContext";
import { AuthContext } from "../../context/AuthContext";

const CheckoutDiscount = ({ class_package_id }) => {
  const { user } = useContext(AuthContext);

  const { discountCode, setDiscountCode, spinnerDescuento, validarDescuento } =
    useContext(CheckoutContext);

  const handleSubmitDescuento = (e) => {
    e.preventDefault();
    validarDescuento(discountCode, class_package_id);
  };

  const renderDescuento = () => {
    if (user !== null) {
      return (
        <form onSubmit={handleSubmitDescuento}>
          <div>
            <label className="bold">Código de Descuento</label>
            <input
              type="text"
              className="form-control w-50 mb-3"
              value={discountCode}
              onChange={(e) => setDiscountCode(e.target.value)}
            />
            <button
              type="submit"
              className="btn btn-outline-light"
              disabled={spinnerDescuento}
            >
              {spinnerDescuento ? (
                <div className="spinner-border"></div>
              ) : (
                "Aplicar"
              )}
            </button>
          </div>
        </form>
      );
    }
  };

  return <div className="card">{renderDescuento()}</div>;
};

export default CheckoutDiscount;
